import { bar } from "./bar";
import { barAndBubble } from "./barAndBubble";
import { dualBar } from "./dualBar";
import { stackedBarChart } from "./stackedBarChart";


export const placeholder = {
    'type': 'placeholder',
    '_type': 'Select a Chart',
}
const chartTypes = {
    'placeholder': placeholder,
    'stacked_bar_chart': stackedBarChart,
    'bar_and_bubble_chart': barAndBubble,
    'grouped_bar_chart': dualBar,
    'bar_chart': bar
}

export const chartTypeOptions = Object.keys(chartTypes).map((key) => ({key:key, label:chartTypes[key]._type})).filter((chart) => chart.key !== 'placeholder')

export default chartTypes
